module.exports = __webpack_public_path__ + "img/63ne.a1231065.svg";